<template>
    <div class="b1">
        <div class="popup1" v-if="flag">
            <div class="p_bg" @click.stop="flag = false"></div>
        </div>
        <div class="popup2" v-if="flag1">
            <div class="p_bg"></div>
        </div>
        <div class="body">
            <div class="top">
                <div class="t_left">智能体选择</div>
                <div class="t_right">
                    <div class="tr_item" :class="type == 1 ? 'tri' : ''" @click="btn_tab(1)">官方智能体</div>
                    <div class="tr_item" :class="type == 2 ? 'tri' : ''" @click="btn_tab(2)">我创建的智能体</div>
                </div>
            </div>
            <!-- <div class="top" style="margin-top: 20px;">
                <div class="t_right" style="margin-left: 0;">
                    <div class="tr_item" :class="courseType == 1 ? 'tri' : ''" @click="btn_types(1)">课堂智能体</div>
                    <div class="tr_item" :class="courseType == 2 ? 'tri' : ''" @click="btn_types(2)">教研智能体</div>
                </div>
            </div> -->
            <div class="list" v-if="type == 1">
                <div class="item" :title="item.note" v-for="(item, index) in list" :key="index"
                    @click="btn_item(item, index)">
                    <img class="i_left" :src="webImg + item.icon" />
                    <div class="i_right">
                        <div>{{ item.name }}</div>
                        <div class="line1_">{{ item.note }}</div>
                    </div>
                </div>
            </div>
            <div class="list" v-if="type == 2">
                <div class="add" @click="btn_courseType(cType = courseType), flag = true">
                    <img src="../../assets/img/i53.png" />
                    创建智能体
                </div>
                <div class="item" style="padding: 15px;" :title="item.note" v-for="(item, index) in list" :key="index"
                    @click="btn_item(item, index)">
                    <!-- $router.push({ path: '/createClassroomIntelligentBody', query: { id: item.id, botId: item.botId, icon: item.icon, name: item.name } }) -->
                    <!-- <img class="i_select" src="../../assets/img/i14.png" /> -->
                    <!-- require -->
                    <img class="i_left" :src="webImg + item.icon" />
                    <div class="i_right">
                        <div>{{ item.name }}</div>
                        <div class="line1_">{{ item.description }}</div>
                    </div>
                    <el-button type="primary" size="small" @click.stop="$router.push({ path: '/createClassroomIntelligentBody', query: { id: item.id, botId: item.botId, icon: item.icon, name: item.name } })">编辑</el-button>
                </div>
            </div>
        </div>
        <div class="loading" v-if="flag1">
            <el-progress :text-inside="true" :stroke-width="24" :percentage="progress"></el-progress>
            <div>提示词生成中，请稍候...</div>
        </div>
        <div class="addznt" v-if="flag">
            <div class="c_left">
                <div class="cl_title">
                    <div class="clt_left">创建智能体</div>
                    <div class="clt_right">
                        <el-upload style="text-align: left;" :headers="myHeaders" :http-request="handleUploadImgForm"
                            :on-change="imgSaveToUrl" :show-file-list="false" action class="upload-demo"
                            accept="image/*">
                            <div class="lib_img">
                                <img class="edit" src="../../assets/img/i46.png" />
                                <img class="ibi_img" :src="webImg + icon" />
                            </div>
                        </el-upload>
                    </div>
                </div>
                <!-- <div class="cl_tab">
                    <div class="clt_tab" @click="btn_courseType(1)">
                        <div class="ltt_top">课堂智能体</div>
                        <div class="ltt_bottom" v-if="cType == 1"></div>
                    </div>
                    <div class="clt_tab" @click="btn_courseType(2)">
                        <div class="ltt_top">教研智能体</div>
                        <div class="ltt_bottom" v-if="cType == 2"></div>
                    </div>
                </div> -->
                <div class="cl_box">
                    <!-- <div class="cl_top">
                        <div class="cli_top"><span>*</span>①智能体图标</div>
                        <div class="cli_bottom">
                            <el-upload style="text-align: left;" :headers="myHeaders"
                                :http-request="handleUploadImgForm" :on-change="imgSaveToUrl" :show-file-list="false"
                                action class="upload-demo" accept="image/*">
                                <div class="lib_add" v-if="!icon">
                                    <img src="../../assets/img/i54.png" />
                                    上传图标
                                </div>
                                <img class="lib_img" :src="webImg + icon" v-if="icon" />
                            </el-upload>
                        </div>
                    </div> -->

                    <div class="cl_list">
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>学段</div>
                            <div class="cli_bottom">
                                <el-select v-model="sectionId" placeholder="请选择" @change="sectionChange">
                                    <el-option v-for="item in sectionArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>学科</div>
                            <div class="cli_bottom">
                                <el-select v-model="subjectId" placeholder="请选择" @change="subjectChange">
                                    <el-option v-for="item in subjectArr" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cl_item">
                            <div class="cli_top"><span>*</span>智能体名称</div>
                            <div class="cli_bottom">
                                <el-input v-model="name" type="text" placeholder="请输入智能体名称" maxlength="20"
                                    show-word-limit></el-input>
                            </div>
                        </div>
                        <!-- <div class="cl_item">
                            <div class="cli_top"><span>*</span>③智能体介绍</div>
                            <div class="cli_bottom">
                                <el-input v-model="description" type="text" placeholder="请输入内容" maxlength="500"
                                    show-word-limit></el-input>
                            </div>
                        </div> -->
                        <!-- <div class="cl_item">
                            <div class="cli_top">智能体开场语</div>
                            <div class="cli_bottom">
                                <el-input v-model="openingWords" type="text" placeholder="同学你好，我们一起学习吧！" maxlength="50"
                                    show-word-limit></el-input>
                            </div>
                        </div> -->
                        <div class="cl_item" style="width: 100%;">
                            <div class="cli_top"><span>*</span>智能体开场语</div>
                            <div class="cli_bottom">
                                <el-input type="textarea" :rows="2" v-model="openingWords" placeholder="同学你好，我们一起学习吧！"
                                    maxlength="100"></el-input>
                            </div>
                        </div>
                        <div class="cl_item" style="width: 100%;">
                            <div class="cli_top"><span>*</span>智能体介绍</div>
                            <div class="cli_bottom">
                                <el-input type="textarea" :rows="8" v-model="description" placeholder="请输入内容（最多500字）"
                                    maxlength="500"></el-input>
                            </div>
                        </div>
                        <div class="cl_item" style="width: 100%;">
                            <div class="cli_top">引用文件</div>
                            <div class="cli_bottom">
                                <div class="quote-upload-box">
                                    <el-upload :headers="myHeaders" :http-request="handleUploadQuoteForm"
                                        :on-change="imgSaveToUrl" :show-file-list="false" action class="quote-uploader"
                                        multiple accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx,.txt">
                                        <div class="quote-upload-trigger">
                                            <img class="quote-upload-icon" src="../../assets/img/i7.png" />
                                            <div class="quote-upload-text">点击上传办公文档</div>
                                            <div class="quote-upload-tip">支持 Word、Excel、PPT、PDF、TXT，可多选</div>
                                        </div>
                                    </el-upload>
                                    <div class="quote-file-list" v-if="quoteFileList.length > 0">
                                        <div class="quote-file-item" v-for="(item, index) in quoteFileList" :key="index">
                                            <img class="qfi_icon" :src="settingFileIcon(item.resourceType, item.path)" />
                                            <div class="qfi_info">
                                                <div class="qfi_name line1_">{{ item.name || item.path }}</div>
                                                <div class="qfi_type">{{ getQuoteFileExt(item.name) }} 文档</div>
                                            </div>
                                            <img class="qfi_del" src="../../assets/img/i52.png"
                                                @click.stop="btn_delQuoteFile(index)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- <div class="cl_item">
                            <div class="cli_top"><span>*</span>⑦目标任务</div>
                            <div class="cli_bottom">
                                <el-select v-model="tarId" placeholder="请选择">
                                    <el-option v-for="item in tarArr" :key="item.id" :label="item.targetName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div> -->
                        <!-- <div class="cl_item">
                            <div class="cli_top">⑦知识点</div>
                            <div class="cli_bottom">
                                <el-select v-model="knowledgePointId" placeholder="请选择" @change="knowledgePointsChange">
                                    <el-option v-for="item in knowledgePointArr" :key="item.id"
                                        :label="item.knowledgePointsName" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div> -->
                        <!-- <div class="cl_item" style="width: 100%;">
                            <div class="cli_top"><span>*</span>⑪评价维度</div>
                            <div class="cli_bottom" style="display: flex;align-items: center;flex-wrap: wrap;">
                                <div class="lib_item" :class="item.select ? 'libi' : ''" v-for="(item, index) in wdList"
                                    :key="index" @click="btn_wdItem(item, index)">{{ item.typeName }}</div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="next" @click="btn_next">下一步</div>
            </div>
        </div>
        <el-dialog title="提示" :visible.sync="popup" width="fit-content">
            <div class="cc_box">
                <div class="ccb_box">
                    <div class="c_bottom">
                        <div class="cb_item" v-for="(item, index) in templateList" :key="index" v-if="item.attrName">
                            <div class="cbi_top"><span>*</span>{{ item.attrName }}</div>
                            <div class="cbi_bottom1">
                                <el-select v-model="item.selectName" placeholder="请选择"
                                    @change="oneChange($event, index)">
                                    <el-option v-for="(itemA, indexA) in item.attrValues" :key="indexA"
                                        :value="itemA"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="cb_item" v-for="(item, index) in templateList" :key="index" v-if="!item.attrName">
                            <div class="cbi_top"><span v-if="item.requiredFlag == 1">*</span>{{ item.title }}</div>
                            <div class="cbi_bottom" v-if="item.type != 2">
                                <input maxlength="5000" placeholder="请输入" v-model="item.text" v-if="item.type == 0"
                                    @input="inputChange($event, index)" />
                                <textarea maxlength="5000" placeholder="请输入" v-model="item.text" v-if="item.type == 1"
                                    @input="inputChange($event, index)"></textarea>
                            </div>
                            <div class="cbi_bottom1" v-if="item.type == 2">
                                <el-select v-model="item.text" placeholder="请选择" @change="twoChange($event, index)">
                                    <el-option v-for="(itemA, indexA) in item.opt" :key="indexA"
                                        :value="itemA"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="popup = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import { userInfo, helperLabelId, listAllAgent, botList, evaluateTypeOption, ossToken, sectionSubject, targetOption, childrenList, knowledgePointsOption, defaultPrompt, nextPromptOption, promptInfo, helperInfo } from '@/apis/index'
export default {
    data() {
        return {
            type: 1,
            list: [],
            courseType: 1,
            flag: false,
            flag1: false,
            cType: 1,
            wdList: [],
            description: '',
            icon: 'upload/qimiyun/2025/07/18/be1d93bd-c656-4636-9880-56a94f489898.png',
            name: '',
            openingWords: '',
            myHeaders: { "X-Token": ossToken() },
            sectionArr: [],
            sectionId: '',
            subjectArr: [],
            subjectId: '',
            tarArr: [],
            tarId: '',
            knowledgePointArr: [],
            knowledgePointId: '',
            knowledgePointsName: '',
            popup: false,
            helperObj: {},
            templateList: [],
            prompts: '',
            currentItem: {},
            progress: 0,
            introduce: '',
            info: {},
            quoteFileList: []
        }
    },
    watch: {
        '$route.query.type'(newVal) {
            this.courseType = this.$route.query.type
            this.getbotList()
            this.getEvaluateTypeOption()
        }
    },
    created() {
        if (sessionStorage.getItem('selectedTab')) {
            this.type = sessionStorage.getItem('selectedTab')
        }
        if (this.$route.query.type) {
            this.courseType = this.$route.query.type
        }
    },
    mounted() {
        this.getUserInfo()
        this.getbotList()
        this.getEvaluateTypeOption()
    },
    methods: {
        getUserInfo() {
            userInfo().then(res => {
                console.log(res, 'userInfo')
                var info = res.data
                sectionSubject(2).then(resA => {
                    console.log(resA, 'sectionSubject');
                    this.sectionArr = resA.data
                    this.sectionId = info.techSectionId
                    this.subjectId = info.techSubjectId
                    this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList
                })
            })
        },
        confirm() {
            this.popup = false
            console.log(this.templateList, 'templateList');
            this.$router.push({ path: '/intelligentBodyChat', query: { id: this.currentItem.id, icon: this.currentItem.icon, name: this.currentItem.name, templateList: JSON.stringify(this.templateList) } })
            this.currentItem = {}
        },
        btn_item(item, index) {
            console.log(item, 'item');
            this.currentItem = item
            this.getHelperInfo(item.id, data => {
                console.log(data, 'datasss');
                if (this.templateList.length > 0) {
                    this.popup = true
                } else {
                    this.$router.push({ path: '/intelligentBodyChat', query: { id: this.currentItem.id, icon: this.currentItem.icon, name: this.currentItem.name } })
                }
            });
        },
        getHelperInfo(techHelperId, fun) {
            helperInfo(techHelperId).then(res => {
                console.log(res, 'helperInfo');
                this.helperObj = res.data
                if (this.helperObj.extraAttrFlag == 0) {
                    if (this.helperObj.promptList) {
                        this.helperObj.promptList.forEach(itemB => {
                            itemB.text = ''
                            if (itemB.opt) {
                                itemB.opt = itemB.opt.split(',')
                            }
                        })
                        this.templateList = this.helperObj.promptList
                        this.prompts = this.helperObj.prompt
                    }
                } else {
                    if (this.helperObj.attrList) {
                        this.helperObj.attrList.forEach(itemB => {
                            itemB.text = ''
                        })
                        this.templateList = this.helperObj.attrList
                        this.templateList.forEach(e => {
                            if (e.attrValues) {
                                e.selectName = ''
                                e.attrValues = e.attrValues.split(',')
                            }
                        })
                        this.prompts = this.helperObj.prompt
                    }
                }
                fun(res.data)
            })
        },
        inputChange(e, index) {
            console.log(this.templateList, 'templateList');
            this.$forceUpdate()
        },
        twoChange(e, index) {
            console.log(e, 'twoChange', index);
            console.log(this.templateList, 'templateList2');
            this.templateList[index].text = e
            this.$forceUpdate()
        },
        oneChange(e, index) {
            console.log(e, 'oneChange', index);
            this.templateList[index].selectName = e
            var list = []
            this.templateList.forEach(itemA => {
                if (itemA.selectName) {
                    const newObj = {
                        [itemA.attrName]: itemA.selectName
                    };
                    list.push(newObj)
                }
            })

            const result = list.reduce((accumulator, current) => {
                return {
                    ...accumulator,
                    ...current
                };
            }, {});

            if (this.templateList[index + 1] && this.templateList[index + 1].attrName) {
                nextPromptOption({
                    helperId: this.helperObj.id,
                    attrValue: JSON.stringify(result)
                }).then(res => {
                    console.log(res, 'nextPromptOption');
                    this.templateList[index + 1].attrValues = res.data
                })
            }

            var templateList = this.templateList.filter(item => item.attrName)
            if (templateList.length !== list.length) {
                return
            }

            promptInfo({
                helperId: this.helperObj.id,
                attrValue: JSON.stringify(result)
            }).then(res => {
                this.prompts = res.data.prompt
                this.templateList = this.templateList.filter((itemA) => {
                    console.log(itemA, 'itemA');
                    return itemA.attrName;
                });
                res.data.promptList.forEach(itemB => {
                    itemB.text = ''
                })
                this.templateList = [...this.templateList, ...res.data.promptList]
                this.$forceUpdate()
            })
        },
        startProgress(duration, onUpdate) {
            const startTime = Date.now();
            const endTime = startTime + duration;
            const timer = setInterval(() => {
                const now = Date.now();
                let progress = ((now - startTime) / duration) * 100;

                if (progress >= 100) {
                    progress = 100;
                    clearInterval(timer);
                    if (onUpdate) onUpdate(progress);
                    // if (onComplete) onComplete();
                } else {
                    if (onUpdate) onUpdate(progress);
                }
            }, 100); // 每100毫秒更新一次进度
        },
        getDefaultPrompt(fun) {
            this.flag1 = true
            this.startProgress(30000, progress => {
                console.log(progress, 'progress');
                this.progress = parseInt(progress)
            })
            defaultPrompt({
                courseType: this.courseType,
                description: this.description,
                knowledgePointsName: this.knowledgePointsName,
                name: this.name,
                sectionName: this.sectionArr.find(item => item.id == this.sectionId).name,
                subjectName: this.subjectArr.find(item => item.id == this.subjectId).name,
                quoteFiles: this.getQuoteFilesValue(),
                // targetName: this.tarArr.find(item => item.id == this.tarId).targetName,
            }).then(res => {
                console.log(res, 'defaultPrompt');
                fun(res.data)
            }).finally(() => {
                this.flag1 = false
            })
        },
        knowledgePointsChange(e) {
            console.log(e, 'ee');
            this.knowledgePointsName = this.knowledgePointArr.find(item => item.id == e).knowledgePointsName
        },
        // 知识点
        getKnowledgePointsOption() {
            knowledgePointsOption(this.subjectId).then(res => {
                console.log(res, 'knowledgePointsOption');
                this.knowledgePointArr = res.data
            })
        },
        //获取目标数据
        getTargetOption() {
            targetOption(this.subjectId).then(res => {
                this.tarArr = res.data
            })
        },
        // 学科变化事件
        subjectChange(e) {
            this.tarId = ''
            this.tarArr = []
            this.knowledgePointId = ''
            this.knowledgePointArr = []
            // this.getTargetOption(e)
            this.getKnowledgePointsOption()
        },
        // 学段变化事件
        sectionChange(e) {
            this.subjectId = ''
            this.subjectArr = []
            this.tarId = ''
            this.tarArr = []
            this.knowledgePointId = ''
            this.knowledgePointArr = []
            console.log(e, 'e', this.sectionArr.find(item => item.id == e));
            this.subjectArr = this.sectionArr.find(item => item.id == e).subjectList
        },
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                this.sectionArr = res.data
            })
        },
        btn_next() {
            if (!this.icon) {
                return this.$message.warning('请上传智能体图标')
            }
            if (!this.name) {
                return this.$message.warning('请填写智能体名称')
            }
            if (!this.description) {
                return this.$message.warning('请填写智能体介绍')
            }
            if (!this.openingWords) {
                return this.$message.warning('请填写开场语')
            }
            if (!this.sectionId) {
                return this.$message.warning('请选择学段')
            }
            if (!this.subjectId) {
                return this.$message.warning('请选择学科')
            }
            // if (!this.tarId) {
            //     return this.$message.warning('请选择目标任务')
            // }
            // var arr = []
            // arr = this.wdList.filter(item => item.select === true)
            // if (arr.length < 3) {
            //     return this.$message.warning('请至少选择3个维度')
            // }
            this.flag = false
            this.getDefaultPrompt((prompt) => {
                var obj = {
                    description: this.description,
                    icon: this.icon,
                    name: this.name,
                    openingWords: this.openingWords,
                    courseType: this.cType,
                    // wdList: this.wdList.filter(item => item.select === true).map(item => item.id),
                    sectionId: this.sectionId,
                    subjectId: this.subjectId,
                    // classTargetId: this.tarId,
                    knowledgePointId: this.knowledgePointId,
                    quoteFileList: this.quoteFileList
                }
                localStorage.setItem('prompt', prompt)
                this.$router.push(`/createClassroomIntelligentBody?obj=${JSON.stringify(obj)}`)
            })
        },
        btn_wdItem(item, index) {
            item.select = !item.select
        },
        btn_delQuoteFile(index) {
            this.quoteFileList.splice(index, 1);
            this.$forceUpdate();
        },
        getQuoteFileExt(name) {
            if (!name || !name.includes('.')) {
                return '办公';
            }
            return name.split('.').pop().toUpperCase();
        },
        getQuoteFilesValue() {
            return this.quoteFileList.map(item => item.path).join(',');
        },
        handleUploadQuoteForm(param) {
            const allowedExt = ['doc', 'docx', 'pdf', 'xls', 'xlsx', 'ppt', 'pptx', 'txt'];
            const fileName = param.file.name || '';
            const ext = fileName.includes('.') ? fileName.split('.').pop().toLowerCase() : '';
            if (!allowedExt.includes(ext)) {
                return this.$message.warning('仅支持上传常见办公文档（Word、Excel、PPT、PDF、TXT）');
            }
            this.uploadFileToOss(param, (fileItem) => {
                this.quoteFileList.push(fileItem);
            });
        },
        uploadFileToOss(param, onSuccess) {
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                ossData.append("file", param.file);
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: ossRes.host,
                    data: ossData
                }).then((res2) => {
                    onSuccess({
                        path: res2.data.url,
                        resourceType: 3,
                        select: 1,
                        name: param.file.name
                    });
                    loading.close();
                }).catch(() => {
                    loading.close();
                    this.$message.error('上传失败，请重试');
                });
            }).catch(() => {
                loading.close();
                this.$message.error('上传失败，请重试');
            });
        },
        handleUploadImgForm(param) {
            console.log(param, 'imgup');
            const formData = new FormData();
            formData.append("multipart", param.file);
            let loading = this.$loading({
                lock: true,
                text: "上传中，请稍候...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            // 获取上传token
            ossToken(param.file.name).then(res => {
                let ossRes = JSON.parse(res.data);
                console.log(ossRes, 'getOssToken')
                const ossData = new FormData();
                Object.keys(ossRes).forEach((key) => {
                    ossData.append(key, ossRes[key]);
                });
                console.log(param.file, 'param.file')
                ossData.append("file", param.file);
                var url = ossRes.host;
                axios({
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    method: 'post',
                    url: url,
                    data: ossData
                }).then(async (res2) => {
                    console.log(res2, 'getOssToken axios')
                    this.icon = res2.data.url
                    console.log(this.icon, 'icon');
                    loading.close();
                })
            })
        },
        // 选取图片后自动回调，里面可以获取到文件
        imgSaveToUrl(event) {
            console.log(event, 'eventOnchange');
        },
        // 获取维度数据
        getEvaluateTypeOption() {
            evaluateTypeOption(this.cType, '').then(res => {
                console.log(res, 'evaluateTypeOption');
                res.data.forEach(e => { e.select = false })
                this.wdList = res.data
            })
        },

        btn_courseType(cType) {
            this.cType = cType
            this.evaluateTypeId = []
            this.quoteFileList = []
            this.getEvaluateTypeOption()
        },
        btn_types(courseType) {
            this.courseType = courseType
            this.getbotList()
        },
        getbotList() {
            botList(this.type, this.courseType, 1).then(res => {
                console.log(res, 'res');
                this.list = res.data
            })
        },
        btn_tab(type) {
            this.type = type
            sessionStorage.setItem('selectedTab', type)
            // this.courseType = 1
            this.getbotList()
        },
        btn_type(index) {
            this.typeIndex = index
            this.labelId = this.typeList[index].labelId
            this.lIndex = 0
            this.getList()
            // this.bottomList = this.typeList[this.typeIndex].helperObjList
        },
        btn_label(item, index) {
            this.lIndex = index
            this.bottomList = item.helperList
            console.log(item, 'item');
        },
        getHelperLabelId() {
            helperLabelId(this.labelId).then(res => {
                console.log(res, 'helperLabelId');
                this.labelList = res.data
                if (this.obj && this.obj.childId) {
                    this.lIndex = this.labelList.findIndex((item) => item.labelId == this.obj.childId)
                    this.obj = {}
                }
                this.bottomList = this.labelList[this.lIndex].helperList
            })
        },
        getList() {
            listAllAgent(1).then(res => {
                console.log(res, 'listAllAgent');
                this.typeList = res.data
                if (this.obj && this.obj.parentId) {
                    this.labelId = this.obj.parentId
                    this.typeIndex = this.typeList.findIndex((item) => item.labelId == this.obj.parentId)
                    console.log(this.typeIndex, 'typeIndex', this.obj);
                }
                if (this.labelId == '' || this.labelId == null || this.labelId == undefined) {
                    this.labelId = this.typeList[0].labelId
                }
                this.obj.parentId = ''
                this.getHelperLabelId()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-select {
        width: 100% !important;
    }

    .el-progress-bar__innerText {
        color: #000000 !important;
    }
}

.quote-upload-box {
    width: 100%;
}

.quote-uploader {
    width: 100%;

    ::v-deep .el-upload {
        width: 100%;
    }
}

.quote-upload-trigger {
    width: 100%;
    min-height: 108px;
    border: 1px dashed #C5D9F2;
    border-radius: 10px;
    background: linear-gradient(180deg, #FAFCFF 0%, #F4F8FF 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 18px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;

    &:hover {
        border-color: #2992FF;
        background: #F2F8FF;
        box-shadow: 0 4px 12px rgba(41, 146, 255, 0.08);
    }

    .quote-upload-icon {
        width: 28px;
        height: 28px;
        margin-bottom: 10px;
    }

    .quote-upload-text {
        font-size: 14px;
        font-weight: 600;
        color: #2992FF;
        line-height: 20px;
    }

    .quote-upload-tip {
        margin-top: 6px;
        font-size: 12px;
        color: #9AA5B5;
        line-height: 18px;
        text-align: center;
    }
}

.quote-file-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 14px;
}

.quote-file-item {
    width: 100%;
    height: 58px;
    border-radius: 10px;
    background: #F7F9FC;
    border: 1px solid #E8EEF5;
    padding: 10px 12px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    transition: all 0.2s ease;

    &:hover {
        border-color: #C5D9F2;
        background: #F3F8FF;
    }

    .qfi_icon {
        width: 32px;
        height: 32px;
        flex-shrink: 0;
    }

    .qfi_info {
        flex: 1;
        min-width: 0;
        margin: 0 10px;
    }

    .qfi_name {
        font-size: 13px;
        font-weight: 600;
        color: #2C2C2C;
        line-height: 18px;
    }

    .qfi_type {
        margin-top: 2px;
        font-size: 11px;
        color: #9AA5B5;
        line-height: 16px;
    }

    .qfi_del {
        width: 18px;
        height: 18px;
        cursor: pointer;
        flex-shrink: 0;
        opacity: 0.55;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 1;
        }
    }
}

.cc_box {
    width: 380px;
    height: 450px;
    border-radius: 7px 7px 7px 7px;
    display: flex;
    flex-direction: column;
    // margin-bottom: 30px;
    z-index: 9999;

    .ccb_title {
        font-weight: bold;
        font-size: 14px;
        color: #333333;
        padding: 18px;
        border-bottom: 1px solid #ECECEC;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .cbt_right {
            width: 110px;
            height: 25px;
            border: 1px solid#9EA3A7;
            border-radius: 8px 8px 8px 8px;
            display: flex;
            align-items: center;
            overflow: hidden;

            .ltr {
                background-color: #399AFF !important;
                color: #fff !important;
            }

            div {
                flex: 1;
                height: 100%;
                line-height: 25px;
                text-align: center;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                cursor: pointer;
            }
        }
    }

    // .ccb_box::-webkit-scrollbar {
    //     display: none;
    // }
    .ccb_box {
        width: 100%;
        height: 0;
        flex: 1;
        overflow-y: scroll;
        box-sizing: border-box;
        padding: 0 18px;

        .c_bottom {
            height: 100%;
            // width: 65%;
            box-sizing: border-box;

            .cb_item {
                width: 100%;
                margin-bottom: 20px;

                .cbi_top {
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    color: #252525;

                    span {
                        font-weight: 500;
                        font-size: 16px;
                        color: #FF0000;
                        margin-right: 5px;
                    }
                }

                .cbi_bottom1 {
                    width: 100%;
                    margin-top: 10px;

                    .el-select {
                        width: 100%;
                    }
                }

                .cbi_bottom {
                    width: 100%;
                    margin-top: 10px;

                    input {
                        width: 100%;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E2E6ED;
                        box-sizing: border-box;
                        padding: 0 10px;
                        font-weight: 500;
                        font-size: 14px;
                    }

                    textarea {
                        width: 100%;
                        height: 100px;
                        background: #FFFFFF;
                        border-radius: 2px 2px 2px 2px;
                        border: 1px solid #E2E6ED;
                        box-sizing: border-box;
                        padding: 10px;
                        font-weight: 500;
                        font-size: 14px;
                    }
                }
            }
        }

        .cbbi {
            border: 1px solid #2992FF !important;
        }

        .cbb_item {
            // width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            .bbi_left {
                width: 14px;
                height: 14px;
            }

            .bbi_right {
                flex: 1;
                margin-left: 14px;
                display: flex;
                align-items: center;

                .bir_left {
                    width: 36px;
                    height: 36px;
                    border-radius: 4px;
                }

                .bir_right1 {
                    flex: 1;
                    margin-left: 7px;
                    display: flex;
                    align-items: center;

                    .rr1_left {
                        flex: 1;
                        margin-right: 10px;

                        div:nth-child(1) {
                            font-weight: 500;
                            font-size: 14px;
                            color: #000000;
                        }

                        div:nth-child(2) {
                            font-weight: 500;
                            font-size: 11px;
                            color: #999999;
                            margin-top: 7px;
                        }
                    }

                    .rr1r {
                        color: #2992FF !important;
                    }

                    .rr1_right {
                        font-weight: 500;
                        font-size: 14px;
                        color: #999999;
                    }
                }

                .bir_right {
                    flex: 1;
                    margin-left: 7px;

                    div:nth-child(1) {
                        font-weight: 500;
                        font-size: 14px;
                        color: #000000;
                    }

                    div:nth-child(2) {
                        font-weight: 500;
                        font-size: 11px;
                        color: #999999;
                        margin-top: 7px;
                    }

                }
            }
        }
    }
}

.b1 {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    // z-index: 1;
    .loading {
        color: rgb(64, 158, 255);
        z-index: 3;
        position: absolute;
        top: 45%;

        div {
            font-size: 16px;
            margin-top: 20px;
        }
    }

    .addznt {
        width: 820px;
        // height: 500px;
        background: #FFFFFF;
        border-radius: 16px;
        position: absolute;
        top: 370px;
        /* 距离顶部 50% */
        left: 50%;
        /* 距离左侧 50% */
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 35px 50px;
        z-index: 3;

        .c_left {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .cl_title {
                width: 100%;
                font-weight: bold;
                font-size: 19px;
                color: #252525;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .clt_left {}

                .clt_right {

                    .lib_img {
                        width: 80px;
                        height: 80px;
                        cursor: pointer;
                        position: relative;

                        .ibi_img {
                            border-radius: 8px;
                            width: 100%;
                            height: 100%;
                        }

                        .edit {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            width: 15px;
                            height: 15px;
                        }
                    }
                }
            }

            .cl_tab {
                width: 100%;
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .clt_tab {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-right: 50px;
                    cursor: pointer;

                    .ltt_top {
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                    }

                    .ltt_bottom {
                        width: 46px;
                        height: 2px;
                        background: #2992FF;
                        border-radius: 4px 4px 4px 4px;
                        margin-top: 10px;
                    }
                }
            }

            .cl_box {
                width: 100%;
                flex: 1;
                height: 0;

                // overflow-y: scroll;
                .cl_top {
                    width: 100%;
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;

                    .cli_top {
                        width: 85px;
                        font-weight: bold;
                        font-size: 12px;
                        color: #252525;

                        span {
                            font-weight: 500;
                            font-size: 16px;
                            color: #FF0000;
                        }
                    }

                    .cli_bottom {

                        // width: 100%;
                        // width: 255px;
                        .lib_btn {
                            width: 91px;
                            height: 37px;
                            border-radius: 8px 8px 8px 8px;
                            border: 1px solid #399AFF;
                            font-weight: bold;
                            font-size: 16px;
                            color: #2992FF;
                            text-align: center;
                            line-height: 37px;
                            margin-left: 20px;
                            cursor: pointer;
                        }

                        .lib_img {
                            width: 80px;
                            height: 80px;
                            cursor: pointer;
                            border-radius: 8px;
                        }

                        .lib_add {
                            width: 80px;
                            height: 80px;
                            background: #FFFFFF;
                            border-radius: 2px 2px 2px 2px;
                            border: 1px solid #E2E6ED;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            font-weight: 500;
                            font-size: 14px;
                            color: #999999;
                            cursor: pointer;

                            img {
                                width: 18px;
                                height: 18px;
                                margin-bottom: 10px;
                            }
                        }
                    }
                }

                .cl_list {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .cl_item {
                        width: 47%;
                        margin-bottom: 20px;
                        display: flex;
                        align-items: center;

                        .cli_top {
                            width: 85px;
                            font-weight: bold;
                            font-size: 12px;
                            color: #252525;

                            span {
                                font-weight: 500;
                                font-size: 16px;
                                color: #FF0000;
                            }
                        }

                        .cli_bottom {
                            flex: 1;

                            // height: 25px;
                            .libi {
                                background: #2992FF !important;
                                color: #fff !important;
                            }

                            .lib_item {
                                width: fit-content;
                                padding: 6px 13px;
                                background: #F1F1F1;
                                border-radius: 1px 1px 1px 1px;
                                font-weight: 500;
                                font-size: 10px;
                                color: #020202;
                                margin-right: 10px;
                                margin-bottom: 10px;
                                user-select: none;
                                cursor: pointer;
                            }

                            // width: 100%;
                            // width: 255px;
                            .lib_btn {
                                width: 91px;
                                height: 37px;
                                border-radius: 8px 8px 8px 8px;
                                border: 1px solid #399AFF;
                                font-weight: bold;
                                font-size: 16px;
                                color: #2992FF;
                                text-align: center;
                                line-height: 37px;
                                margin-left: 20px;
                                cursor: pointer;
                            }

                            .lib_img {
                                width: 80px;
                                height: 80px;
                                cursor: pointer;
                                border-radius: 8px;
                            }

                            .lib_add {
                                width: 80px;
                                height: 80px;
                                background: #FFFFFF;
                                border-radius: 2px 2px 2px 2px;
                                border: 1px solid #E2E6ED;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                                font-weight: 500;
                                font-size: 14px;
                                color: #999999;
                                cursor: pointer;

                                img {
                                    width: 18px;
                                    height: 18px;
                                    margin-bottom: 10px;
                                }
                            }
                        }
                    }
                }


                .cl_file {
                    width: 100%;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    margin-top: 20px;

                    .clf_left {
                        font-weight: bold;
                        font-size: 16px;
                        color: #252525;
                    }

                    .clf_right {}
                }

                .cl_fileArr {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    flex-wrap: wrap;
                    margin-top: 20px;

                    .clf_item {
                        width: 150px;
                        display: flex;
                        align-items: center;

                        .lfi_icon {
                            width: 16px;
                            height: 16px;
                        }

                        .lfi_name {
                            font-weight: bold;
                            font-size: 16px;
                            color: #252525;
                            margin: 0 10px;
                        }

                        .lfi_del {
                            width: 16px;
                            height: 16px;
                            cursor: pointer;
                        }
                    }
                }
            }



            .cl_box::-webkit-scrollbar {
                // display: none;
            }

            .next {
                width: 125px;
                height: 33px;
                background: #2992FF;
                border-radius: 5px 5px 5px 5px;
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
                text-align: center;
                line-height: 33px;
                user-select: none;
                cursor: pointer;
            }
        }
    }

    .popup1 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 2;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }

    .popup2 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 2;

        .p_bg {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }
    }
}

.body {
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;

    .search {
        width: 700px;
        height: 50px;
        background: #FFFFFF;
        box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #E9EBF2;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 30px;
        margin-top: 20px;

        input {
            flex: 1;
            margin-right: 30px;
            font-size: 16px;
        }

        img {
            width: 20px;
            height: 20px;
        }
    }

    .top {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 40px;

        .t_left {
            font-weight: bold;
            font-size: 20px;
            color: #000000;
        }

        .t_right {
            flex: 1;
            margin-left: 30px;
            display: flex;
            align-items: center;

            .tri {
                background: #2992FF !important;
                color: #FFFFFF !important;
            }

            .tr_item {
                width: fit-content;
                height: 34px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #E9EBF2;
                font-weight: 500;
                font-size: 14px;
                color: #333333;
                box-sizing: border-box;
                padding: 0 25px;
                line-height: 34px;
                cursor: pointer;
                margin-right: 10px;
            }
        }
    }

    .label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0;

        .li {
            background: #2992FF !important;
            color: #FFFFFF !important;
        }

        .l_item {
            width: fit-content;
            height: 34px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 0 25px;
            line-height: 34px;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            cursor: pointer;
            margin: 0 5px;
        }
    }

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        flex: 1;
        width: 100%;
        height: 0;
        display: flex;
        align-items: center;
        align-content: flex-start;
        flex-wrap: wrap;
        margin-top: 20px;
        overflow-y: scroll;
        margin-bottom: 20px;

        .add {
            width: 288px;
            height: 89px;
            background: #FFFFFF;
            box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.05);
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 15px 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            margin-bottom: 15px;
            font-weight: 400;
            font-size: 16px;
            color: #080808;
            cursor: pointer;

            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }

        .item:nth-child(4n) {
            margin-right: 0 !important;
        }

        .item {
            width: 288px;
            background: #FFFFFF;
            box-shadow: 0px 7px 6px 0px rgba(0, 0, 0, 0.05);
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #E9EBF2;
            box-sizing: border-box;
            padding: 15px 20px;
            display: flex;
            align-items: center;
            margin-right: 15px;
            margin-bottom: 15px;
            cursor: pointer;

            .i_select {
                width: 18px;
                height: 18px;
                margin-right: 10px;
            }

            .i_left {
                width: 58px;
                height: 58px;
                border-radius: 4px;
            }

            .i_right {
                flex: 1;
                margin-left: 20px;

                div:nth-child(1) {
                    font-weight: 400;
                    font-size: 16px;
                    color: #080808;
                }

                div:nth-child(2) {
                    font-weight: 400;
                    font-size: 14px;
                    color: #A0A0A0;
                    margin-top: 10px;
                }
            }

        }
    }

    .bottom {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #F0F0F0;
        padding-top: 20px;
        margin-top: 20px;
        margin-bottom: 20px;

        .btn {
            width: 164px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 8px 8px 8px 8px;
            border: 0px solid #399AFF;
            font-weight: bold;
            font-size: 16px;
            color: #399AFF;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin: 0 7px;
        }

        .btn1 {
            width: 164px;
            height: 40px;
            background: #399AFF;
            border-radius: 8px 8px 8px 8px;
            font-weight: bold;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
            line-height: 40px;
            cursor: pointer;
            margin: 0 7px;
        }
    }
}
</style>
